import {
  useCompareContext,
  useProductContext,
  useRequestContext,
  useRouterContext,
  useSearchContext,
} from '../../../context/PlpContext';
import { useExperiencesContext } from '../../experiences/Experiences';
import { useSocialProofData } from '../hooks/useSocialProofData';
import { useProductCardSize } from '../../../hooks/useProductCardSize';
import { useEnergyDrawerData } from '../../energy-drawer/useEnergyDrawerData';
import { usePlpViewType } from '../../../hooks/usePlpViewType';

export const useProductGridData = () => {
  const { setProductContext, totalNumberOfResults, products } =
    useProductContext();

  const { personalisedPlp } = useSearchContext();

  const pageCorrelationId = useRequestContext();

  const experiencesContext = useExperiencesContext();

  const router = useRouterContext();

  const compare = useCompareContext();

  const { socialProofingMessages } = useSocialProofData();

  const { isLargeCardSize } = useProductCardSize();

  const { isListView } = usePlpViewType('useProductGridData');

  const { openEnergyDrawer } = useEnergyDrawerData();

  const imageSize = isLargeCardSize
    ? '(max-width: 567px) calc(100vw - 32px), (min-width: 568px) and (max-width:767px) calc(50vw - 24px), (min-width: 768px) and (max-width:1200px) calc(25vw - 30), 282px'
    : '(max-width: 567px) calc(50vw - 24px), (min-width: 568px) and (max-width:767px) calc(33vw - 21px), (min-width: 768px) and (max-width:1200px) calc(19vw - 32), 205px';

  const imageWidths = ['117', '234', '330', '366', '411', '564', '686'];

  return {
    compare,
    experiencesContext,
    imageSize,
    imageWidths,
    isLargeCardSize,
    isListView,
    openEnergyDrawer,
    pageCorrelationId,
    personalisedPlp,
    products,
    router,
    setProductContext,
    socialProofingMessages,
    totalNumberOfResults,
  };
};
